/** Fixed simulation rate. Never a variable dt — determinism depends on it. */
export const TICK_HZ = 120;
export const DT = 1 / TICK_HZ;

/** Render interpolation target; core does not care, but the contract's consumers do. */
export const RENDER_HZ = 60;

/** Token body shape: a coin. One shape in every cabinet, because it is one token. */
export const TOKEN_HALF_HEIGHT = 0.12;
export const TOKEN_BASE_MASS = 1;
export const TOKEN_BASE_RESTITUTION = 0.32;
export const TOKEN_BASE_FRICTION = 0.42;

/** Coins vs tickets: machines ratchet out paper for performance, coins for value. */
export const TICKET_RATIO: Record<string, number> = {
  pachinko: 0.25,
  muenzschieber: 0.15,
  bandit: 0.35,
  roulette: 0.3,
  greifer: 0.5,
};
